export * from './component';
export * from './delete-krankheit.service';
export * from './post-krankheit.service';
